import React, { useCallback, useState } from 'react';
import { useEventCallback } from '../../../helpers/hooks';
import { AddItemDialog } from './AddItemDialog';
import ListItem from './ListItem';
import { ItemHeader } from './ItemHeader';
import * as eventHelper from '../../../helpers/event-helper';

const Tasks = ({
  tasks,
  tasksName,
  tasksTitle,
  notes,
  notesName,
  notesTitle,
  setFieldValue,
}) => {
  const [isAddTaskDialogOpen, setIsAddTaskDialogOpen] = useState(false);
  const [isAddNoteDialogOpen, setIsAddNoteDialogOpen] = useState(false);

  const totalNoteCount = notes.length;
  const totalTaskCount = tasks.length;
  const completedTaskCount = eventHelper.getCompletedTasks(tasks).length;

  const addItem = useCallback(
    (fieldName, items, description, isCompleted = undefined) => {
      const item = {
        description,
        isCompleted,
        createdBy: 'User',
      };

      setFieldValue(fieldName, [...items, item]);
    },
    [setFieldValue]
  );

  const deleteItem = useCallback(
    (fieldName, items, index) =>
      setFieldValue(fieldName, [
        ...items.slice(0, index),
        ...items.slice(index + 1),
      ]),
    [setFieldValue]
  );

  const editItem = useCallback(
    (fieldName, items, id, description, isCompleted = undefined) => {
      const index = items.findIndex(item => item._id === id);

      const item = {
        ...items[index],
        description,
        isCompleted,
        updatedBy: 'User',
      };

      setFieldValue(fieldName, [
        ...items.slice(0, index),
        item,
        ...items.slice(index + 1),
      ]);
    },
    [setFieldValue]
  );

  /* Notes */
  const handleNoteItemAdd = useEventCallback(description => {
    addItem(notesName, notes, description);
  });

  const handleNotesItemDelete = useEventCallback(index =>
    deleteItem(notesName, notes, index)
  );

  const handleNoteItemEdited = useEventCallback((description, id) => {
    editItem(notesName, notes, id, description);
  });

  /* Tasks */
  const handleTaskItemAdd = useEventCallback((description, isCompleted) => {
    addItem(tasksName, tasks, description, isCompleted);
  });

  const handleTaskItemDelete = useEventCallback(index =>
    deleteItem(tasksName, tasks, index)
  );

  const handleTaskEdited = useEventCallback((description, id, isCompleted) => {
    editItem(tasksName, tasks, id, description, isCompleted);
  });

  return (
    <>
      <ItemHeader
        onAddClick={() => setIsAddTaskDialogOpen(true)}
        tasks={tasks}
        counter={`${completedTaskCount}/${totalTaskCount}`}
        isHighlighted={eventHelper.getUncompletedTasks(tasks).length}
        title={tasksTitle}
      />
      {tasks?.map((task, index) => {
        return (
          <ListItem
            mode="task"
            name={tasksName}
            item={task}
            key={task._id}
            index={index}
            total={totalTaskCount}
            onDelete={handleTaskItemDelete}
            onEdit={handleTaskEdited}
            setFieldValue={setFieldValue}
          />
        );
      })}
      <ItemHeader
        onAddClick={() => setIsAddNoteDialogOpen(true)}
        notes={notes}
        isHighlighted={totalNoteCount > 0}
        counter={totalNoteCount}
        title={notesTitle}
      />
      {notes?.map((note, index) => {
        return (
          <ListItem
            mode="note"
            name={notesName}
            item={note}
            key={note._id}
            index={index}
            total={totalNoteCount}
            onDelete={handleNotesItemDelete}
            onEdit={handleNoteItemEdited}
            setFieldValue={setFieldValue}
          />
        );
      })}
      <AddItemDialog
        isOpen={isAddTaskDialogOpen}
        onItemAdd={handleTaskItemAdd}
        onClose={() => setIsAddTaskDialogOpen(false)}
        mode={'task'}
      />
      <AddItemDialog
        isOpen={isAddNoteDialogOpen}
        onItemAdd={handleNoteItemAdd}
        onClose={() => setIsAddNoteDialogOpen(false)}
        mode={'note'}
      />
    </>
  );
};
export default React.memo(Tasks);
